import type { StoreObject } from '@apollo/client/utilities';
import { gql } from 'apollo-angular';

export const ARTICLE_VERSION_TYPE_POLICY = {
    ArticleVersion: {
      // Synthetic version ids (-1, -2, …) repeat across documents. Use the
      // document version id so those drafts do not share one cache entry.
      keyFields: (version: Readonly<StoreObject>) => {
        const id = typeof version['id'] === 'number' ? version['id'] : null;
        const documentVersionId = typeof version['documentVersionId'] === 'string'
          ? version['documentVersionId']
          : null;
        if (id != null && id > 0) {
          return ['id'];
        }
        if (documentVersionId) {
          return ['documentVersionId'];
        }
        return ['id'];
      },
      fields: {
        approved: {
          read(existing = false) {
            return existing;
          }
        }
      }
    }
  };
  

export const GET_ARTICLE_VERSIONS_QUERY = gql`
query ArticleVersion($id: String, $filter: String, $skip: Int, $take: Int) {
    article(id: $id) {
        id
        deleteInfo {
            isDeleted
        }
        author {
            id
            forename
            surname
            displayName
        }
        versions(filter: $filter) {
            hasPreviousPage
            hasNextPage
            totalItems
            items {
                id
                articleId
                versionMajor
                versionMinor
                publishedDate
                approved
                articleStateId
                articleCategoryId
                thumbnailFileInventoryId
                isLatest
                isPublished
                versionNumber
                title
                synopsis
                content
                # tags
                thumbnailFileInventory {
                    url
                }
            }
        }
    }
}
`;

export const POST_ARTICLE_VERSION_MUTATION = gql`
mutation ArticleVersionMutate($args: ArticleVersionInput!) {
  articleVersionMutate(args: $args) {
    id
  }
}
`;

export const POST_ARTICLE_VERSION_DELETION = gql`
mutation ArticleVersionDelete($id: Int!) {
    articleVersionDelete(id: $id) {
        id
    }
}
`;
